import React from 'react'
import { NumberInput } from '../../../../Components/Input/NumberInput'

export function PriorityInput({
  priority,
  setPriority,
  errorMessage,
  disabled,
}: {
  priority: number
  setPriority: (priority: number) => void
  errorMessage: string
  disabled: boolean
}) {
  return (
    <NumberInput
      label="Priority"
      errorMessage={errorMessage}
      value={priority}
      style={{
        flexGrow: 1,
        maxWidth: 'calc(50% - 8px)',
      }}
      onChange={(value?: number) =>
        setPriority(value === undefined ? 5 : value!)
      }
      disabled={disabled}
      required
      min={0}
      max={1e9}
      precision={5}
    />
  )
}
